import { render, staticRenderFns } from "./attr-imgList.vue?vue&type=template&id=63951c4a&scoped=true&"
import script from "./attr-imgList.vue?vue&type=script&lang=js&"
export * from "./attr-imgList.vue?vue&type=script&lang=js&"
import style0 from "./attr-imgList.vue?vue&type=style&index=0&id=63951c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63951c4a",
  null
  
)

export default component.exports